import { ApiClientService, EntityApiService, RequestConfig } from '@dfl/react-security';
import { IWarehouse } from 'modules/inventory/warehouse/interfaces';
import { ACTIVITY_SALES_OFFER_METRIC_ENUM } from '../constants/metrics/sales.offer-metric';
import { ANALYTIC_OFFER_METRIC } from '../interfaces/ISalesOffer';

class AnalyticSalesOfferService extends EntityApiService<IWarehouse> {
  summary = (offerId: string, params?: any, config?: RequestConfig): Promise<any> => {
    return this.handleResponse(
      ApiClientService.post(
        this.getPath(`/sales/${offerId}/${ACTIVITY_SALES_OFFER_METRIC_ENUM.SUMMARY}`),
        params,
        config,
      ),
    );
  };

  statusSummary = (params?: any, config?: RequestConfig): Promise<any> => {
    return this.handleResponse(
      ApiClientService.post(this.getPath(`/${ANALYTIC_OFFER_METRIC.STATUS_SUMMARY}`), params, config),
    );
  };

  offerHistogram = (offerId: string, params?: any, config?: RequestConfig): Promise<any> => {
    return this.handleResponse(
      ApiClientService.post(
        this.getPath(`/sales/${offerId}/${ACTIVITY_SALES_OFFER_METRIC_ENUM.OFFER_HISTOGRAM}`),
        params,
        config,
      ),
    );
  };

  reactiveClients = (offerId: string, params?: any, config?: RequestConfig): Promise<any> => {
    return this.handleResponse(
      ApiClientService.post(
        this.getPath(`/sales/${offerId}/${ACTIVITY_SALES_OFFER_METRIC_ENUM.REACTIVE_CLIENTS}`),
        params,
        config,
      ),
    );
  };

  searchByMetric = (metric: ANALYTIC_OFFER_METRIC, params?: any, config?: RequestConfig): Promise<any> => {
    return this.handleResponse(ApiClientService.post(this.getPath(`/sales/${metric}`), params, config));
  };
}

export default new AnalyticSalesOfferService('/ms-analytics/api/v1/offers');
